(() => {
  const editorMotionNode = document.getElementById('EaEditorMotion');
  const editorMotion = editorMotionNode ? JSON.parse(editorMotionNode.textContent) : null;
  const header = document.querySelector('[data-n-header]');

  // Kopfzeile: nach dem ersten Scrollen mit feiner Linie
  if (header) {
    const syncScrolled = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    syncScrolled();
    addEventListener('scroll', syncScrolled, { passive: true });

    const count = header.querySelector('.n-count');
    if (count) {
      new MutationObserver(() => { count.hidden = count.textContent.trim() === '0'; })
        .observe(count, { childList: true, characterData: true, subtree: true });
    }
  }

  // Mega-Menü: Klick, Tastatur und mit Maus auch Hover
  const items = header ? [...header.querySelectorAll('[data-n-item]')] : [];
  if (items.length) {
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    let openTimer = 0;
    let closeTimer = 0;
    const openItem = () => items.find((item) => item.classList.contains('is-open'));
    const setOpen = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('button').setAttribute('aria-expanded', String(open));
      header.classList.toggle('has-mega', Boolean(openItem()));
    };
    const closeAll = (except) => items.forEach((item) => { if (item !== except) setOpen(item, false); });

    items.forEach((item) => {
      const button = item.querySelector('button');
      button.addEventListener('click', () => {
        clearTimeout(openTimer);
        const open = !item.classList.contains('is-open');
        closeAll(item);
        setOpen(item, open);
      });
      item.addEventListener('pointerenter', () => {
        if (!finePointer.matches || editorMotion?.menuHover === false) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => { closeAll(item); setOpen(item, true); }, openItem() ? 0 : 110);
      });
      item.addEventListener('pointerleave', () => {
        if (!finePointer.matches || editorMotion?.menuHover === false) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(item, false), 180);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !item.classList.contains('is-open')) return;
        setOpen(item, false);
        button.focus();
      });
    });
    document.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('[data-n-item]')) closeAll();
    });
    header.querySelectorAll('.n-nav > a').forEach((link) => {
      link.addEventListener('pointerenter', () => { if (finePointer.matches) { clearTimeout(openTimer); closeAll(); } });
    });
  }

  // Reiter (Kontaktweg-Vergleich, Produktinformationen): Klick und Pfeiltasten; ohne Skript bleiben alle Inhalte sichtbar
  document.querySelectorAll('[data-tabs]').forEach((group) => {
    const tabs = [...group.querySelector('[role=tablist]').querySelectorAll('[role=tab]')];
    const select = (tab, focus) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        select(tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length], true);
      });
    });
    select(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  });

  if (matchMedia('(prefers-reduced-motion: reduce)').matches || editorMotion?.mode === 'off') return;
  const customMotion = editorMotion?.mode === 'custom';

  // Unterseiten: ganze Inhaltsblöcke steigen wie auf der Startseite auf (nie Formulare oder Kaufbereich)
  const body = document.body;
  if (!body.classList.contains('template-index') && !body.classList.contains('origin-studio')) {
    const skip = 'form,input,select,textarea,dialog,iframe,canvas,origin-phone-demo,.p-buy,[data-og-preview],.ea-reveal,.ea-reveal-media,[data-reveal]';
    document.querySelectorAll('#MainContent section > .container > *, #MainContent .container > section > *, #MainContent .rte > *').forEach((element) => {
      if (element.matches(skip) || element.querySelector(skip) || element.closest('.ea-reveal,.p-buy')) return;
      element.setAttribute('data-reveal', '');
    });
  }

  // Einblendung: nur Elemente unterhalb der ersten Ansicht, gestaffelt je Gruppe
  const targets = [...document.querySelectorAll('[data-reveal],[data-reveal-media]')]
    .filter((element) => element.getBoundingClientRect().top > innerHeight * 0.9);
  targets.forEach((element) => {
    const siblings = [...element.parentElement.children].filter((child) => child.hasAttribute('data-reveal'));
    element.style.setProperty('--n-delay', `${Math.min(Math.max(siblings.indexOf(element), 0), 4) * (customMotion ? editorMotion.stagger : 90)}ms`);
    element.classList.add('n-pending');
  });
  const pending = new Set(targets);

  // Vollbreite Bilder zoomen beim Hereinscrollen von 1.12 auf 1
  const bleeds = editorMotion?.parallax === 'off' ? [] : [...document.querySelectorAll('[data-bleed] img')];

  let frame = 0;
  const update = () => {
    frame = 0;
    pending.forEach((element) => {
      if (element.getBoundingClientRect().top >= innerHeight * 0.88) return;
      element.classList.remove('n-pending');
      pending.delete(element);
    });
    bleeds.forEach((image) => {
      const rect = image.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > innerHeight) return;
      const progress = Math.min(Math.max((innerHeight - rect.top) / (innerHeight * 0.9), 0), 1);
      image.style.transform = `scale(${(1.12 - 0.12 * progress).toFixed(4)})`;
    });
  };
  // Zeitgeber als Absicherung, falls der Browser keine Animationsbilder liefert (z. B. Hintergrund-Tab)
  const onScroll = () => {
    if (frame) return;
    frame = requestAnimationFrame(update);
    setTimeout(() => { if (frame) { cancelAnimationFrame(frame); update(); } }, 150);
  };
  update();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
})();
